export default __webpack_public_path__ + "static/media/IconTemplates.764d0022.svg";